var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryFlowFillWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_123_9",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_123_9",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACxUlEQVR4nO3dsWoUQRzH8U2TRonahlSi76AIh4idduH6QErRV9A+kjbgG5jkAWKhYGNlFdAHEATtjHaX4iuDG7jI3iaX+c/Of2Z/X7gyt8N8srezt7tJ0yillFJKKaWUUkoppZRSSqnegA1gqhdhDjay/7q0EOpf09weAjmfQJwlEGcJxFkCcVbVIO+BFwmW0+E9PyQac7UgO8BKwjGvAK8TjLtKkB/A6gDjXgV+Go+9SpCjAcf+znjsVYJ8GXDsX43HXiVI6MkA436KfdWC/AaeAesJxrsOPAf+JBh3tSClJhBnCcRZAnGWQJwlEGcJpBQQYE3LXl8gn4FbyVF0HnJpEAZBEchSIOlRBLI0SFoUgVwJJB2KQK4MkgalApAZsAdsGVyv3wX2F7wW9cl0SVw4yAx4YDgXfRPPICiFg+yZTEI8iB1K4SDbJhI2IDb3ExQO8tJEwgbkBLg/dpDvlqucCJCAcc9qECWDhI6Bx8D1TCA2e0ZFIDnPQ+z2DIFEg9hjtBvSHrI8SBxG32ecQJYGiTtmhB8ObyIQE5D4PaN9EwQSDWKHERJINEj8x9T8lgSS6a6TLoyQQDKALMIICWRgkD6MC9o32Pa19uuLY8pumhvDBGRuHDeAb4wZJBLDFCQEvGLkIEeRg7AG2WbkIGvt5UMvIG8oN7NjSAyK5TFkApxSbqarrItQFt3esmtw+8xWu2ecUnbm5yFh+fmxa0s9P6Ov3xOfqXeiCCTjAztdKALJ/ATV/ygCcfBI2zyKQJw8Y3iGIhBHD3323XOqVda59BSuswTiLBcgm7lnwVGbHkAe5p4FR008gNxsn0Qae7NB/jDAZQIOc8+Gg942XgLuRl51LL1fwO3GU+1NCicjxXjUeAy4AxyM5JgyCx9T7vaMrsLBrb36V+u/QpqExUzueVZKKaWUUkoppZRSSimllGoK7C9Zrfv3xS309AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryFlowFillWhite);
export default __webpack_public_path__ + "static/media/InventoryFlowFillWhite.d7a5dd7785f750aa5df1705e387737c8.svg";
export { ForwardRef as ReactComponent };